import { Link as RLink } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import { Tab as MTab } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const Tab = styled(MTab) `
  && {
    min-width: 150px;
    max-width: 264px;
    display: inline-flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-evenly;
  }
`;
export const Link = styled(RLink) `
  && {
    display: inline-flex;
    min-width: max-content;
  }
`;
export const InfoIconStyle = styled(InfoIcon) `
  margin-left: 5px;
  color: white;
  background-color: ${theme.palette.text.secondary};
  border-radius: 50%;
`;
